import { Field, Form } from 'react-final-form';
import { Button, InputField, KeywordsField, TextareaField } from 'components';
import { CampaignSettings } from 'models/CampaignSettings';
import useCampaignSettings from 'hooks/useCampaignSettings';
import { useTanstackMutation } from 'hooks';
import toast from 'react-hot-toast';
import {
  getCampaignDefaults,
  updateCampaignDefaults,
} from 'api/campaign-defaults';
import { queryClient } from 'react-query';

import './CampaignParams.styles.scss';

const CampaignParams = () => {
  const { data } = useCampaignSettings();
  const { mutate: mutateUpdateInfo, isPending: isPendingUpdate } =
    useTanstackMutation<CampaignSettings>({
      onSuccess: (data) => {
        queryClient.setQueryData([getCampaignDefaults()], data);
        toast.success('Successfully updated campaign settings.');
      },
      onError: (error) => {
        console.error(error);
        toast.error('Error on updating campaign settings.');
      },
    });

  return (
    <div className="campaign-params">
      <Form<CampaignSettings>
        onSubmit={(data) => {
          mutateUpdateInfo({
            path: updateCampaignDefaults(),
            method: 'patch',
            body: data,
          });
        }}
        initialValues={data || {}}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className="register-form">
            <Field
              name="scrapeKeywords"
              label="Keywords"
              component={KeywordsField}
            />
            <Field
              name="launchLimit"
              label="Launch limit"
              component={InputField}
              type="number"
              step={1}
            />
            <Field
              name="queryPrompt"
              label=" Default scraping campaign prompt"
              placeholder="Enter your default scraping campaign prompt here..."
              component={TextareaField}
              rows={20}
            />
            <Field
              name="personalCampaignPrompt"
              label=" Default personal campaign prompt"
              placeholder="Enter your default personal campaign prompt here..."
              component={TextareaField}
              rows={20}
            />

            <Button
              type="submit"
              isLoading={isPendingUpdate}
              className="submit-button"
            >
              Save changes
            </Button>
          </form>
        )}
      />
    </div>
  );
};

export default CampaignParams;
